module.exports = __webpack_public_path__ + "img/parti_icon.ac6c25a0.svg";